import script from "./ContractInformationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractInformationView.vue?vue&type=script&setup=true&lang=js"

import "./ContractInformationView.vue?vue&type=style&index=0&id=684511ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684511ca"]])

export default __exports__